import { types } from "../types/types";


const initialState={
    list: [],
    sinHabitacion: []
}



export const roomReducer = (state=initialState,action) => {
    switch (action.type) {
        case types.roomsLoadingList:
            return {
                ...state,
                ...action.payload
            };
        case types.roomsDeleteFolio:
            return {
                ...state,
                list: [...state.list.filter(e => (e.folio !== action.payload))]
            }
        case types.roomsAddFolio:
            return {
                ...state,
                list: [
                    ...state.list,
                    action.payload
                ]
            }
    
        default:
            return state;
    }
}